import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/lib/query-keys';
import { UserPreferences } from '@/types/preferences.types';
import { getInitialPreferences } from '@/hooks/usePreferenceManager';

export function usePreferencesQuery() {
  return useQuery<UserPreferences | null>({
    queryKey: queryKeys.userPreferences.all(),
    queryFn: () => getInitialPreferences(),
    staleTime: Infinity,
  });
}
